import { createReducer, on } from '@ngrx/store';
import * as MuseumActions from '@Actions/museum.actions';
import { MuseumsPaginatedState } from '@State/app.state';

export const initialMuseumsPaginatedState: MuseumsPaginatedState = {
  paginationData: {},
  loadError: null
};

const MAX_CACHED_PAGES = 10;

export const museumsPaginatedReducer = createReducer(
  initialMuseumsPaginatedState,
  on(MuseumActions.setMuseumsForPage, (state, { page, museums }) => {

    const updatedPaginationData = { ...state.paginationData, [page]:museums };
    const pageNumbers = Object.keys(updatedPaginationData).map(Number);

    //se ho gia' n=MAX_CACHED_PAGES pagine in cache, elimina la prima per far spazio alla n+1
    if(pageNumbers.length > MAX_CACHED_PAGES) {
      const oldestPage = Math.min(...pageNumbers);
      delete updatedPaginationData[oldestPage];
    }

    return { ...state, paginationData:updatedPaginationData }

  }),
  on(MuseumActions.museumsPaginatedLoadError, (state, { error }) => {
    return {
      ...state,
      loadError: error
    };
  }),
  on(MuseumActions.clearPaginatedMuseums, () => {
    return initialMuseumsPaginatedState;
  })
);

